import { Box, Button, Container, Grid, GridItem, Image, Link, Text, useBreakpointValue } from '@chakra-ui/react'
import ABOUT from '../constants/about'
import { TypeAnimation } from 'react-type-animation'
import { AnimatePresence, motion, useScroll, useTransform } from 'framer-motion'
import { useRef } from 'react'

const Hero = () => {
  const container = useRef()

  const { scrollYProgress } = useScroll({
    target: container,
    offset: ['start end', 'end start']
  })

  const aboutMeText = useBreakpointValue({
    base: 0,
    md: useTransform(scrollYProgress, [0, 1], [-200, 200])
  })
  const skillsText = useBreakpointValue({
    base: 0,
    md: useTransform(scrollYProgress, [0, 1], [-10, 10])
  })
  const descriptionText = useBreakpointValue({
    base: 0,
    md: useTransform(scrollYProgress, [0, 1], [-100, 100])
  })

  // console.log('scrollYProgress', scrollYProgress);
  // console.log('aboutMeText', aboutMeText);

  return (
    <Box
      ref={container}
      bgColor={'blackAlpha.50'}
      backgroundImage="url('/assets/images/hero.webp')"
      // minH={'100vh'}
      // background="linear-gradient(360deg, #16222a, #3a6073)"
      bgPos={'center'}
      bgAttachment={'fixed'}
      bgRepeat={'no-repeat'}
      bgSize={'cover'}
      display={'flex'}
      color={'white'}
      flexDirection={'column'}>
      <Container maxW={'container.xl'}>
        <Box
          // bgColor={"green"}
          py={{
            base: 4,
            md: 4
          }}
          display={'flex'}
          flexDirection={'row'}
          gap={4}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <Box display={'flex'} flexDirection={'row'} gap={4} alignItems={'center'}>
            <Image
              src={ABOUT.profile}
              alt={'profile'}
              borderRadius={'full'}
              boxSize={{
                base: 10,
                md: 12
              }}
              bgSize={'cover'}
              objectFit={'cover'}
            />
            <Text
              fontSize={{
                base: 'initial'
              }}
              fontWeight={'bold'}>
              {ABOUT.name}
            </Text>
          </Box>

          <Box
            display={{
              base: 'none',
              md: 'flex'
            }}
            flexDirection={'row'}
            gap={14}
            alignItems={'center'}>
            <Link
              href={'#certificates'}
              width={{
                base: 'auto',
                md: '100%'
              }}
              fontWeight={600}>
              Certificates
            </Link>
            <Link
              href={'#projects'}
              width={{
                base: 'auto',
                md: '100%'
              }}
              fontWeight={600}>
              Projects
            </Link>
            <Link
              href={'#contact'}
              width={{
                base: 'auto',
                md: '100%'
              }}
              fontWeight={600}>
              Contact
            </Link>
            <Link
              href={ABOUT.pdf_projects}
              isExternal
              width={{
                base: 'auto',
                md: '100%'
              }}
              fontWeight={600}>
              <Button bgColor={'green.600'}>Projects</Button>
            </Link>
          </Box>
        </Box>
      </Container>

      <Container maxW={'container.xl'}>
        <Grid
          templateColumns={{
            base: 'repeat(1, 1fr)',
            md: 'repeat(4, 1fr)'
          }}
          gap={{
            base: 8,
            md: 20
          }}
          pt={{
            base: 14,
            xl: 24
          }}
          // bgColor={"orange"}
          pb={{
            base: 20,
            md: 28,
            xl: 32
          }}>
          <GridItem
            // bgColor={"blue"}
            colSpan={{
              base: 1,
              md: 3
            }}>
            <Box
              textAlign={{
                base: 'left',
                md: 'left'
              }}
              mb={{
                base: 8,
                md: 12,
                lg: 14
              }}>
              <AnimatePresence>
                <Box
                  as={motion.div}
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  style={{
                    y: aboutMeText
                  }}
                  variants={{
                    hidden: {
                      opacity: 0,
                      y: 80
                    },
                    visible: {
                      opacity: 1,
                      y: 0,
                      transition: {
                        duration: 0.75
                      }
                    }
                  }}>
                  <Text
                    fontSize={{
                      base: '3xl',
                      md: '6xl',
                      lg: '7xl'
                    }}
                    fontWeight={'bold'}>
                    About me
                  </Text>
                </Box>
              </AnimatePresence>
              <Box
                style={{
                  y: skillsText
                }}
                as={motion.div}>
                <Text
                  fontSize={{
                    base: 'md',
                    md: '1rem',
                    lg: '1rem',
                    xl: '1.25rem'
                  }}>
                  {ABOUT.skills[0]} |{' '}
                  <TypeAnimation
                    sequence={[
                      ABOUT.skills[1],
                      1000,
                      ABOUT.skills[2],
                      1000,
                      ABOUT.skills[3],
                      1000,
                      ABOUT.skills[4],
                      1000,
                      ABOUT.skills[5],
                      1000,
                      ABOUT.skills[6],
                      1000
                    ]}
                    repeat={Infinity}
                  />
                </Text>
              </Box>
            </Box>

            <AnimatePresence>
              <Box
                as={motion.div}
                initial={{
                  opacity: 0
                }}
                style={{
                  y: descriptionText
                }}
                animate={{
                  opacity: 1,
                  transition: {
                    duration: 2
                  }
                }}
                textAlign={{
                  base: 'left',
                  md: 'left'
                }}>
                <Text
                  fontSize={{
                    base: '1rem',
                    md: '1rem',
                    lg: '1rem',
                    xl: '1.25rem'
                  }}
                  fontWeight={'500'}>
                  As a full-stack web developer with expertise in both backend and frontend technologies, I specialize in frameworks like Laravel,
                  CodeIgniter, Express.js, React/Next.js, and React Native. Since starting my programming career in 2021, I have contributed to
                  various projects, including Lingoni.com, Stufast.id, and Sikembang.com.
                  <br />
                  <br />I excel in both independent and collaborative environments and am dedicated to delivering high-quality solutions that meet
                  client needs and drive business success.
                </Text>
              </Box>
            </AnimatePresence>
          </GridItem>
        </Grid>
      </Container>
    </Box>
  )
}

export default Hero
